import { render, staticRenderFns } from "./Lumpsum.vue?vue&type=template&id=1635e2cf&scoped=true"
import script from "./Lumpsum.vue?vue&type=script&lang=js"
export * from "./Lumpsum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635e2cf",
  null
  
)

export default component.exports